export default __webpack_public_path__ + "static/media/priscila-almeida-title.178d837a.png";